import { render, staticRenderFns } from "./Speciality.vue?vue&type=template&id=33cc5f5a&scoped=true&"
import script from "./Speciality.vue?vue&type=script&lang=js&"
export * from "./Speciality.vue?vue&type=script&lang=js&"
import style0 from "./Speciality.vue?vue&type=style&index=0&id=33cc5f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc5f5a",
  null
  
)

export default component.exports